// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaFilter, CriteriaFilterSchema } from 'api/gen/CriteriaFilter';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

// Female filter settings with ids exposed as farmIds.

const requiredPart = t.interface({
  breederId: t.union([PositiveIntegerSchema, t.null]),
  farmIds: t.union([t.array(PositiveIntegerSchema), t.null]),
  filters: t.array(CriteriaFilterSchema),
});

export const FemaleCriteriaFiltersSchema = excess(requiredPart);

export interface FemaleCriteriaFilters extends t.TypeOf<typeof FemaleCriteriaFiltersSchema> {}
